import { render, staticRenderFns } from "./fast-score-board.vue?vue&type=template&id=dd0f65a4&scoped=true"
import script from "./fast-score-board.vue?vue&type=script&lang=js"
export * from "./fast-score-board.vue?vue&type=script&lang=js"
import style0 from "./fast-score-board.vue?vue&type=style&index=0&id=dd0f65a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0f65a4",
  null
  
)

export default component.exports